export default __webpack_public_path__ + "static/media/email.a288c5fc.svg";